import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface HistorialRevisionBimestral {
  id?: number;
  placa: string;
  centroDiagnostico: string;
  revisionAprobada: string;
  ultimaRevision: string;
  proximaRevision: string;
  estado?: number;
}

@Injectable({
  providedIn: 'root'
})
export class HistorialRevisionBimestralService {
  
  private apiUrl =  `${environment.apiUrl}/api/historial_bimestral`; 
  constructor(private http: HttpClient) {}

  /** Crear historial */
  create(data: HistorialRevisionBimestral): Observable<HistorialRevisionBimestral> {
    return this.http.post<HistorialRevisionBimestral>(this.apiUrl, data);
  }

  /** Obtener todos los historiales activos y estadística */
  getAll(): Observable<{ historial: HistorialRevisionBimestral[], estadisticas: any }> {
    return this.http.get<{ historial: HistorialRevisionBimestral[], estadisticas: any }>(this.apiUrl);
  }

  /** Obtener historial por centro diagnóstico */
  getByCentro(centroDiagnostico: string): Observable<HistorialRevisionBimestral[]> {
    return this.http.get<HistorialRevisionBimestral[]>(`${this.apiUrl}/centro/${centroDiagnostico}`);
  }

  /** Obtener historial por ID */
  getById(id: number): Observable<HistorialRevisionBimestral> {
    return this.http.get<HistorialRevisionBimestral>(`${this.apiUrl}/${id}`);
  }

  /** Obtener historial por placa */
  getByPlaca(placa: string): Observable<HistorialRevisionBimestral[]> {
    return this.http.get<HistorialRevisionBimestral[]>(`${this.apiUrl}/placa/${placa}`);
  }

  /** Actualizar historial */
  update(id: number, data: Partial<HistorialRevisionBimestral>): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data);
  }

  /** Inactivar historial (eliminación lógica) */
  inactivarPorId(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, {});
  }
}
